import { render, staticRenderFns } from "./PodiumPlace.vue?vue&type=template&id=9925f86c&scoped=true&"
import script from "./PodiumPlace.vue?vue&type=script&lang=js&"
export * from "./PodiumPlace.vue?vue&type=script&lang=js&"
import style0 from "./PodiumPlace.vue?vue&type=style&index=0&id=9925f86c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9925f86c",
  null
  
)

export default component.exports